import SelectField from '../../../../common/formComponents/SelectField/SelectField';
import TextField from '../../../../common/formComponents/TextField/TextField';
import { getInputOptions } from '../../utils/getInputOptions';

export const getAddAccountFieldsData = (
  accountTypesOptions,
  accountTypesLoading
) => {
  return [
    {
      label: 'Услуга',
      name: 'typeId',
      options: getInputOptions({
        requiredErrMsg: 'Выберите услугу',
        fieldType: 'object',
      }),
      span: 8,
      element: SelectField,
      selectOptions: accountTypesOptions,
      valueKey: 'id',
      contentKey: 'name',
      selectProps: {
        loading: accountTypesLoading,
        placeholder: 'Выберите услугу',
        labelInValue: true,
        getPopupContainer: () => document.querySelector('.addAccountModal'),
      },
    },
    {
      label: 'Номер',
      name: 'account',
      options: getInputOptions({
        requiredErrMsg: 'Укажите номер',
      }),
      span: 16,
      element: TextField,
    },
  ];
};
